/** First-touch spend disclosure — the founder's upfront "this uses your budget"
 *  moment. Printed by `m8t bootstrap preflight` ahead of the admin-credentials
 *  notice, and mirrored as Step 0 in guides/install.md + guides/bootstrap.md.
 *
 *  Every claim here is true-in-code and guarded by spend-disclosure.test.ts:
 *   - the cadence tracks DEFAULT_COST_REPORT_CADENCE_DAYS;
 *   - the cost surfaces are scoped to a brain-backed install, because both of
 *     them are (the report needs an App-mode brain worker, and Ezra is one);
 *   - removal points at guides/uninstall.md — there is no uninstall command.
 *
 *  Plain text, not a drawn box: the register asserts phrases against this
 *  string and against the runbook, and box padding would break those matches
 *  on typography rather than meaning.
 *
 *  Keep the wording in lockstep with guides/bootstrap.md — a test enforces it. */
export const SPEND_DISCLOSURE = [
  "You are about to install the m8t platform.",
  "",
  "  - It installs into YOUR Azure subscription and YOUR GitHub account or organization.",
  "  - The Azure resources it creates bill to your Azure account - this uses your budget.",
  "  - With your workers installed, you can ask Ezra what you're spending at any time,",
  "    and you can turn on a cost report by email every two weeks.",
  "  - You can remove it later - see guides/uninstall.md.",
].join("\n");
